import { ImageCard } from './ImageCard';

export type { TypeImageCardProps } from './types';
export default ImageCard;
